export default {
    quantidadeMinima: 3,
}
